export default __webpack_public_path__ + "8c21a895e0857b43af78a512a9d49132.png";